import { type StateCreator } from 'zustand';

import { type AiModelConfig } from '../../api/aimodels/useAiModels';

export type ModelSelectionEntry = {
  selectedModel: AiModelConfig | null;
  isAuto: boolean;
  lastAccessed: number;
};

export type ModelSelectionSlice = {
  // State
  selections: Record<string, ModelSelectionEntry>;

  // Actions
  setSelectedModel: (resourceId: string, model: AiModelConfig) => void;
  setIsAuto: (resourceId: string, isAuto: boolean) => void;
};

const DEFAULT_ENTRY: ModelSelectionEntry = Object.freeze({ isAuto: true, lastAccessed: 0, selectedModel: null });

export const getSelectionForResource = (
  selections: Record<string, ModelSelectionEntry>,
  resourceId: string,
): ModelSelectionEntry => selections[resourceId] ?? DEFAULT_ENTRY;

export type CreateModelSelectionSlice = StateCreator<ModelSelectionSlice, [], [], ModelSelectionSlice>;

export const createModelSelectionSlice: CreateModelSelectionSlice = (set) => ({
  selections: {},
  setIsAuto: (resourceId, isAuto) =>
    set((state) => ({
      selections: {
        ...state.selections,
        [resourceId]: {
          ...getSelectionForResource(state.selections, resourceId),
          isAuto,
          lastAccessed: Date.now(),
        },
      },
    })),
  setSelectedModel: (resourceId, model) =>
    set((state) => ({
      selections: {
        ...state.selections,
        [resourceId]: {
          ...getSelectionForResource(state.selections, resourceId),
          lastAccessed: Date.now(),
          selectedModel: model,
        },
      },
    })),
});
